<div class="container mx-auto p-6">
  <h2 class="text-3xl font-semibold text-center mb-6">Crear Especialista</h2>

  <!-- Botón de Volver (siempre visible) -->
  <div class="mb-4">
    <button
      type="button"
      class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
      (click)="onBack()"
    >
      Volver
    </button>
  </div>

  <!-- Campo de búsqueda por DNI -->
  <div class="mb-4">
    <label for="tipoDocumentoBusqueda" class="block font-semibold mb-1"
      >Buscar por Documento de Identidad</label
    >
    <div class="flex gap-2">
      <select
        id="tipoDocumentoBusqueda"
        class="border border-gray-300 rounded w-full py-2 px-4"
        [(ngModel)]="tipoDocumentoBusqueda"
      >
        <option value="" disabled selected>Seleccione un tipo...</option>
        <option value="DNI">DNI</option>
        <option value="OTRO">Otro Documento</option>
      </select>
      <input
        id="codigoDocumentoBusqueda"
        type="text"
        [(ngModel)]="codigoDocumentoBusqueda"
        class="border border-gray-300 rounded w-full py-2 px-4"
        placeholder="Ingrese el Codigo de Documento"
      />
      <button
        type="button"
        class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
        (click)="buscarUsuario()"
      >
        Buscar
      </button>
    </div>
  </div>

  <!-- Mostrar datos del usuario encontrado -->
  <div *ngIf="usuarioEncontrado" class="mb-4">
    <p>
      <strong>Nombre:</strong> {{ usuarioEncontrado.nombres }}
      {{ usuarioEncontrado.apellidos }}
    </p>
    <p><strong>Correo:</strong> {{ usuarioEncontrado.correo }}</p>
  </div>

  <!-- Formulario para crear nuevo especialista -->
  <form
    [formGroup]="createSpecialistaForm"
    (ngSubmit)="crearUsuario()"
    novalidate
    *ngIf="!usuarioEncontrado"
  >
    <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
      <!-- Tipo de Documento -->
      <div>
        <label for="tipo_documento" class="block font-semibold mb-1"
          >Tipo de Documento</label
        >
        <select
          id="tipo_documento"
          formControlName="tipo_documento"
          class="border border-gray-300 rounded w-full py-2 px-4"
        >
          <option value="" disabled selected>Seleccione un tipo...</option>
          <option value="DNI">DNI</option>
          <option value="OTRO">Otro Documento</option>
        </select>
        <small
          *ngIf="
            createSpecialistaForm.get('tipo_documento')?.touched &&
            createSpecialistaForm.get('tipo_documento')?.invalid
          "
          class="text-red-500"
        >
          Tipo de Documento es obligatorio.
        </small>
      </div>
      <!-- Codigo de Documento -->
      <div>
        <label for="codigo_documento" class="block font-semibold mb-1"
          >Codigo de Documento</label
        >
        <input
          id="codigo_documento"
          type="text"
          formControlName="codigo_documento"
          class="border border-gray-300 rounded w-full py-2 px-4"
          placeholder="Ingrese el Codigo de Documento"
        />
        <small
          *ngIf="
            createSpecialistaForm.get('codigo_documento')?.touched &&
            createSpecialistaForm.get('codigo_documento')?.invalid
          "
          class="text-red-500"
        >
          Codigo de Documento es obligatorio.
        </small>
      </div>

      <!-- Nombres -->
      <div>
        <label for="nombres" class="block font-semibold mb-1">Nombres</label>
        <input
          id="nombres"
          type="text"
          formControlName="nombres"
          class="border border-gray-300 rounded w-full py-2 px-4"
          placeholder="Ingrese los nombres"
        />
        <small
          *ngIf="
            createSpecialistaForm.get('nombres')?.touched &&
            createSpecialistaForm.get('nombres')?.invalid
          "
          class="text-red-500"
        >
          Nombres son obligatorios.
        </small>
      </div>

      <!-- Apellidos -->
      <div>
        <label for="apellidos" class="block font-semibold mb-1"
          >Apellidos</label
        >
        <input
          id="apellidos"
          type="text"
          formControlName="apellidos"
          class="border border-gray-300 rounded w-full py-2 px-4"
          placeholder="Ingrese los apellidos"
        />
        <small
          *ngIf="
            createSpecialistaForm.get('apellidos')?.touched &&
            createSpecialistaForm.get('apellidos')?.invalid
          "
          class="text-red-500"
        >
          Apellidos son obligatorios.
        </small>
      </div>

      <!-- Correo -->
      <div>
        <label for="correo" class="block font-semibold mb-1">Correo</label>
        <input
          id="correo"
          type="email"
          formControlName="correo"
          class="border border-gray-300 rounded w-full py-2 px-4"
          placeholder="Ingrese el correo"
        />
        <small
          *ngIf="
            createSpecialistaForm.get('correo')?.touched &&
            createSpecialistaForm.get('correo')?.invalid
          "
          class="text-red-500"
        >
          Ingrese un correo válido.
        </small>
      </div>

      <!-- Clave -->
      <div>
        <label for="clave" class="block font-semibold mb-1">Clave</label>
        <div class="relative">
          <input
            id="clave"
            [type]="showPassword ? 'text' : 'password'"
            formControlName="clave"
            class="border border-gray-300 rounded w-full py-2 px-4 pr-10"
            placeholder="Ingrese una clave"
          />
          <button
            type="button"
            class="absolute inset-y-0 right-0 px-3 py-2"
            (click)="togglePasswordVisibility()"
          >
            <i [class]="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
          </button>
        </div>
        <small
          *ngIf="
            createSpecialistaForm.get('clave')?.touched &&
            createSpecialistaForm.get('clave')?.invalid
          "
          class="text-red-500"
        >
          Clave es obligatoria.
        </small>
      </div>

      <!-- Unidad Funcional (solo para id_rol = 2) -->
      <div *ngIf="showUnidadFuncional">
        <label for="id_unidad_funcional" class="block font-semibold mb-1">
          Unidad Funcional
        </label>
        <select
          id="id_unidad_funcional"
          formControlName="id_unidad_funcional"
          class="border border-gray-300 rounded w-full py-2 px-4"
        >
          <option [ngValue]="null" disabled selected>
            Seleccione una unidad funcional...
          </option>
          <option
            *ngFor="let unidad of unidadesFuncionales"
            [value]="unidad.id_unidad_funcional"
          >
            {{ unidad.nombre }}
          </option>
        </select>
        <small
          *ngIf="
            createSpecialistaForm.get('id_unidad_funcional')?.touched &&
            createSpecialistaForm.get('id_unidad_funcional')?.invalid
          "
          class="text-red-500"
        >
          Seleccione una unidad funcional.
        </small>
      </div>

      <!-- Área (solo para id_rol = 3) -->
      <div *ngIf="showArea">
        <label for="id_area" class="block font-semibold mb-1"> Área </label>
        <select
          id="id_area"
          formControlName="id_area"
          class="border border-gray-300 rounded w-full py-2 px-4"
        >
          <option [ngValue]="null" disabled selected>
            Seleccione un área...
          </option>
          <option *ngFor="let area of areas" [value]="area.id_area">
            {{ area.nombre }}
          </option>
        </select>
        <small
          *ngIf="
            createSpecialistaForm.get('id_area')?.touched &&
            createSpecialistaForm.get('id_area')?.invalid
          "
          class="text-red-500"
        >
          Seleccione un área.
        </small>
      </div>
    </div>

    <!-- Botón de Guardar -->
    <div class="flex justify-end mt-6">
      <button
        type="submit"
        [disabled]="createSpecialistaForm.invalid"
        class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
      >
        Guardar
      </button>
    </div>
  </form>

  <!-- Formulario para asignar rol a usuario existente -->
  <form
    [formGroup]="asignarRolForm"
    (ngSubmit)="asignarRol()"
    novalidate
    *ngIf="usuarioEncontrado"
  >
    <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
      <!-- Unidad Funcional (solo para id_rol = 2) -->
      <div *ngIf="showUnidadFuncional">
        <label for="id_unidad_funcional" class="block font-semibold mb-1">
          Unidad Funcional
        </label>
        <select
          id="id_unidad_funcional"
          formControlName="id_unidad_funcional"
          class="border border-gray-300 rounded w-full py-2 px-4"
        >
          <option [ngValue]="null" disabled selected>
            Seleccione una unidad funcional...
          </option>
          <option
            *ngFor="let unidad of unidadesFuncionales"
            [value]="unidad.id_unidad_funcional"
          >
            {{ unidad.nombre }}
          </option>
        </select>
        <small
          *ngIf="
            asignarRolForm.get('id_unidad_funcional')?.touched &&
            asignarRolForm.get('id_unidad_funcional')?.invalid
          "
          class="text-red-500"
        >
          Seleccione una unidad funcional.
        </small>
      </div>

      <!-- Área (solo para id_rol = 3) -->
      <div *ngIf="showArea">
        <label for="id_area" class="block font-semibold mb-1"> Área </label>
        <select
          id="id_area"
          formControlName="id_area"
          class="border border-gray-300 rounded w-full py-2 px-4"
        >
          <option [ngValue]="null" disabled selected>
            Seleccione un área...
          </option>
          <option *ngFor="let area of areas" [value]="area.id_area">
            {{ area.nombre }}
          </option>
        </select>
        <small
          *ngIf="
            asignarRolForm.get('id_area')?.touched &&
            asignarRolForm.get('id_area')?.invalid
          "
          class="text-red-500"
        >
          Seleccione un área.
        </small>
      </div>
    </div>

    <!-- Botón de Guardar -->
    <div class="flex justify-end mt-6">
      <button
        type="submit"
        [disabled]="asignarRolForm.invalid"
        class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
      >
        Asignar Rol
      </button>
    </div>
  </form>
</div>
